import { useEffect, useState } from 'react';

export function useGTMInject(isCdkUser: boolean = false) {
  const [isLoadingScript, setIsLoadingScript] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined' || !isCdkUser) {
      return setIsLoadingScript(false);
    }

    // Prevent duplicate script injection
    if (document.getElementById('gtm-script')) {
      return setIsLoadingScript(false);
    }

    // only CDK uses GTM for no
    const gtmId = 'GTM-P8QBWVM';

    // Inject GTM script
    const script = document.createElement('script');
    script.id = 'gtm-script';
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    document.head.appendChild(script);

    // Inject noscript fallback
    const noscript = document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
              height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(noscript);
    setIsLoadingScript(false);
  }, [isCdkUser]);
  return { isLoadingScript };
}
